import { Button, RadioGroup } from "@material-ui/core";
import React, { ReactElement } from "react";
import { useDispatch, useSelector } from "react-redux";
import styled from "styled-components/macro";
import { setSelectedLayout, setSelectedOptionsValue, setSelectionStep } from "../store/selections/selectionsActions";
import { OptionSelection, SelectionStep } from "../store/selections/selectionsTypes";
import { RootState } from "../store/reduxStore";
import Tile from "./Tile";

const LayoutsDiv = styled.div`
	margin: 30px;
	width: 100%;
	flex: 1;
	display: flex;
	align-items: center;
	flex-direction: column;
	overflow-x: hidden;
	text-align: center;
`;

const Subtitle = styled.div`
	padding: 30px;
	font-size: 24px;
	line-height: 28px;
	text-align: left;
`;

const NextButton = styled(Button)`
	font-size: 24px;
	background: #012169;
	border-radius: 3px;
	padding: 15px 110px;
	margin: 10px;
	text-transform: none;
	font-weight: normal;
`;

const Tiles = styled.div`
	flex: 1;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
`;

const LayoutTiles = styled(RadioGroup)`
	flex: 1;
	display: flex;
	flex-flow: row wrap;
	justify-content: space-around;
`;

const Blank = styled.div`
	flex: 1;
`;

const layouts: OptionSelection[] = [{ name: "Left Wall" }, { name: "Right Wall" }];

const options: OptionSelection[] = [{ name: "Kitchen Island" }, { name: "Light Fixtures" }];

function Layouts(): ReactElement {
	const dispatch = useDispatch();
	const optionsValue = useSelector<RootState, number>((state) => state.selections.optionsValue);
	const layoutIndex = useSelector<RootState, number>((state) => state.selections.layoutIndex);

	const handleToggle = (i: number) => {
		const changedBit = 1 << i;
		const newValue = optionsValue ^ changedBit;
		dispatch(setSelectedOptionsValue(newValue));
	};

	const onNext = () => {
		dispatch(setSelectionStep(SelectionStep.Style));
	};

	const handleLayoutChange = (val: number) => {
		dispatch(setSelectedLayout(val));
	};

	return (
		<LayoutsDiv>
			<Subtitle>Let&apos;s start by selecting your kitchen add ons:</Subtitle>
			<LayoutTiles value={layoutIndex} onChange={(ev) => handleLayoutChange(+ev.currentTarget.value)}>
				{layouts.map((layout, i) => {
					return (
						<Tile
							key={i}
							index={i}
							type={"radio"}
							onClick={() => handleLayoutChange(i)}
							label={layout.name}
							thumbUrl={layout.thumb}
						/>
					);
				})}
			</LayoutTiles>
			<Tiles>
				{options.map((option, i) => {
					return (
						<Tile
							key={i}
							index={i}
							type={"checkbox"}
							checked={(optionsValue & (1 << i)) > 0}
							onClick={() => handleToggle(i)}
							label={option.name}
							thumbUrl={option.thumb}
						/>
					);
				})}
			</Tiles>
			<Blank />
			<NextButton variant="contained" color="primary" onClick={onNext}>
				Next
			</NextButton>
		</LayoutsDiv>
	);
}

export default Layouts;
